var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 64,
    viewBox: "0 0 135 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6517 40.7613L25.6564 51.2043L9.94906 41.1177V22.4058L0 15.9902V47.4976L25.6564 63.9997L51.3128 47.4976V26.362H21.7856L41.6517 40.7613Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.737 0L0 15.2547L9.94906 21.6702L23.737 12.7954V0Z",
    fill: "url(#paint0_radial_5421_6266)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5762 0V12.7954L41.3641 21.6702L51.3132 15.2547L27.5762 0Z",
    fill: "url(#paint1_radial_5421_6266)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0781 12.9062H98.5319V50.6509H91.0781V12.9062Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7754 12.9062H65.2292V50.6509H57.7754V12.9062Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.138 18.3595C127.035 14.724 123.1 12.9062 118.494 12.9062H104.93V50.6509H118.494C123.132 50.6509 127.035 48.7975 130.138 45.1977C133.241 41.5979 134.809 37.0714 134.809 31.7964C134.809 26.4858 133.241 21.9949 130.138 18.3595ZM125.116 39.6732C123.42 41.6692 121.213 42.6672 118.494 42.6672H112.383V20.8544H118.494C121.213 20.8544 123.42 21.8523 125.116 23.8483C126.811 25.8442 127.675 28.5174 127.675 31.7251C127.675 35.0042 126.811 37.6773 125.116 39.6732Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5335 20.7118H74.5702C75.6579 20.7118 76.5856 21.1752 77.3854 22.1018C78.1852 23.0642 78.5691 24.2047 78.5691 25.5591C78.5691 26.9491 78.1852 28.0897 77.3854 29.052C76.5856 30.0143 75.6899 30.4777 74.5702 30.4777H68.652L79.1769 50.6153H87.2705L79.8167 36.4655C81.5762 35.4675 83.0477 34.0062 84.1674 32.1528C85.383 30.1212 85.9908 27.9114 85.9908 25.5591C85.9908 22.0662 84.8712 19.0723 82.6638 16.5774C80.4565 14.1181 77.7373 12.8706 74.5702 12.8706H59.4707L63.5335 20.7118Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6515 40.7615L51.3127 47.4978L25.6562 63.9999V51.2045L41.6515 40.7615Z",
    fill: "url(#paint2_radial_5421_6266)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8492 35.3894C79.8492 35.3894 72.8752 37.4566 75.0186 41.5554C77.162 45.6542 79.1774 49.5392 79.1774 49.5392H87.271L79.8492 35.3894Z",
    fill: "url(#paint3_radial_5421_6266)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M130.202 44.6019C130.17 44.6375 130.17 44.6376 130.138 44.6732C127.034 48.3087 123.1 50.1264 118.493 50.1264H112.383V42.1426H118.493C121.212 42.1426 123.42 41.1447 125.115 39.1487C126.811 37.1528 127.674 34.4796 127.674 31.2719C127.674 28.0285 126.811 25.391 125.115 23.395C123.42 21.3991 121.244 20.3299 118.525 20.3299C118.525 20.3299 123.196 20.2942 127.45 23.0743C134.36 27.4939 135.704 38.1507 130.202 44.6019Z",
    fill: "url(#paint4_radial_5421_6266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5421_6266",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4355 17.7041) scale(11.8685 10.8351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#298BE2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5421_6266",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.5875 17.7041) scale(11.8685 10.8351)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#298BE2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5421_6266",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5091 63.3897) scale(12.8282 11.6192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2222,
    stopColor: "#00004F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32416B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5421_6266",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.6074 53.5276) scale(6.3308 7.07489)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2222,
    stopColor: "#00004F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32416B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5421_6266",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.0823 49.0853) scale(10.6118 14.8983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2222,
    stopColor: "#00004F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32416B",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.16c22bbd05825b0ca22a34cf49c536de.svg";
export { ForwardRef as ReactComponent };